/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCarouselItems200ResponseAllOfData } from './GetCarouselItems200ResponseAllOfData';
import {
    GetCarouselItems200ResponseAllOfDataFromJSON,
    GetCarouselItems200ResponseAllOfDataFromJSONTyped,
    GetCarouselItems200ResponseAllOfDataToJSON,
} from './GetCarouselItems200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCarouselItems200ResponseAllOf
 */
export interface GetCarouselItems200ResponseAllOf {
    /**
     * 
     * @type {GetCarouselItems200ResponseAllOfData}
     * @memberof GetCarouselItems200ResponseAllOf
     */
    data: GetCarouselItems200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetCarouselItems200ResponseAllOf interface.
 */
export function instanceOfGetCarouselItems200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetCarouselItems200ResponseAllOfFromJSON(json: any): GetCarouselItems200ResponseAllOf {
    return GetCarouselItems200ResponseAllOfFromJSONTyped(json, false);
}

export function GetCarouselItems200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCarouselItems200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCarouselItems200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetCarouselItems200ResponseAllOfToJSON(value?: GetCarouselItems200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCarouselItems200ResponseAllOfDataToJSON(value.data),
    };
}

